import React from "react";
import Axios from "axios";
import Store from "store";
import {reAuth} from "../../../utils/utils";
import Ship from "./Ship/Ship";

class Ships extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            token: Store.get('accessToken').token,
            items: null
        };
    }

    componentDidMount() {
        let config = {};

        config.headers = {
            'Authorization': 'Bearer ' + this.state.token
        };

        Axios.get(process.env.REACT_APP_API_BASE + '/business/ship', config).then(response => {
            console.log(response);
            if (response.status === 200) {
                this.setState({
                    items: response.data
                });
            } else {
                throw new Error('Smt went wrong with fetching captains');
            }
        })
    }

    renderItems() {
        if (this.state.items) {
            return this.state.items.map(item => {
                return <Ship data={item} />
            })
        }
    }

    render() {

        return (
            <div className={"layout-grid-2"}>
                {this.renderItems()}
            </div>
        );
    }
}

Ships.propTypes = {};

export default Ships;
